"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var EANParser_1 = require("../../core/model/data-dictionary/parsers/EANParser");

var YesNoBooleanParser_1 = require("../../core/model/data-dictionary/parsers/YesNoBooleanParser");

var PropDesc_1 = require("../../core/model/data-dictionary/PropDesc");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EANValidator_1 = require("../../core/model/data-dictionary/validators/EANValidator");

var RequireValidator_1 = require("../../core/model/data-dictionary/validators/RequireValidator");

var DomainObject_1 = require("../../core/model/DomainObject");

var ResearchTypeEnum_1 = require("../../data-pairing/model/ResearchTypeEnum");

var Site_1 = require("../../site/model/Site");
/**
 * Data about competitor's product price gathered from external agency or through web scraping.
 *
 * @author Jaroslav Sevcik
 */


var CompetitorPriceRawData =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CompetitorPriceRawData, _DomainObject_1$Domai);

  /**
   *
   * @param id the internal id
   * @param uploadId the id of a DataUpload entity, identifies data from one upload
   * @param siteType the type of shop - online or physical
   * @param externalCompetitorId the external id of the competitor from source data
   * @param competitorName
   * @param externalSiteId the external id of the competitor site from source data
   * @param address the address of the competitor's site
   * @param city the city of the competitor's site
   * @param externalProductId the external id of the product from source data
   * @param goldId the id of the product from the internal system
   * @param productName
   * @param productSize the size of the product
   * @param productSizeUnit the units the product size is measured in (ml, g, ks, ...)
   * @param regularPrice
   * @param actualPrice the current price of the product, can temporary vary from the regular price
   * @param promo a flag telling if the product is in promo
   * @param sellout a flag telling if the product is in sale
   * @param category the lowest category of the product
   * @param ean
   * @param eanDescription
   * @param date the date the data were collected
   * @param researchType the type of a research the source data belong to
   * @param available a flag telling if the product is currently available at the competitor's store
   * @param productContent the content of the product (e.g. 95% meat)
   * @param productSpecification detailed specification of the product
   * @param supplier the name a supplier of the product
   * @param comment comment from the field researcher on the product
   * @param isFromWebScraping
   *
   */
  function CompetitorPriceRawData(id, uploadId, siteType, externalCompetitorId, competitorName, externalSiteId, address, city, externalProductId, goldId, productName, productSize, productSizeUnit, regularPrice, actualPrice, promo, sellout, category, ean, eanDescription, date, researchType, available, productContent, productSpecification, supplier, comment, isFromWebScraping) {
    var _this;

    _classCallCheck(this, CompetitorPriceRawData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceRawData).call(this));
    _this.id = id;
    _this.uploadId = uploadId;
    _this.siteType = siteType;
    _this.externalCompetitorId = externalCompetitorId;
    _this.competitorName = competitorName;
    _this.externalSiteId = externalSiteId;
    _this.address = address;
    _this.city = city;
    _this.externalProductId = externalProductId;
    _this.goldId = goldId;
    _this.productName = productName;
    _this.productSize = productSize;
    _this.productSizeUnit = productSizeUnit;
    _this.regularPrice = regularPrice;
    _this.actualPrice = actualPrice;
    _this.promo = promo;
    _this.sellout = sellout;
    _this.category = category;
    _this.ean = ean;
    _this.eanDescription = eanDescription;
    _this.date = date;
    _this.researchType = researchType;
    _this.available = available;
    _this.productContent = productContent;
    _this.productSpecification = productSpecification;
    _this.supplier = supplier;
    _this.comment = comment;
    _this.isFromWebScraping = isFromWebScraping;
    return _this;
  }

  return CompetitorPriceRawData;
}(DomainObject_1.DomainObject);

exports.CompetitorPriceRawData = CompetitorPriceRawData;

CompetitorPriceRawData.agencySchema = function () {
  var bld = new StructPropBuilder_1.StructPropBuilder(CompetitorPriceRawData.name);
  return {
    id: bld.id('id'),
    uploadId: bld.str('uploadId', new RequireValidator_1.RequireValidator()),
    siteType: bld.senum('siteType', Site_1.SiteType, 'enum/SiteType'),
    competitorName: bld.str('competitorName', new RequireValidator_1.RequireValidator()),
    externalCompetitorId: bld.str('externalCompetitorId', new RequireValidator_1.RequireValidator()),
    externalSiteId: bld.str('externalSiteId', new RequireValidator_1.RequireValidator()),
    address: bld.opt(bld.str('address', new RequireValidator_1.RequireValidator())),
    city: bld.opt(bld.str('city')),
    externalProductId: bld.opt(bld.str('externalProductId')),
    goldId: bld.opt(bld.str('goldId')),
    productName: bld.str('productName', new RequireValidator_1.RequireValidator()),
    productSize: bld.opt(bld.num('productSize')),
    productSizeUnit: bld.opt(bld.str('productSizeUnit')),
    regularPrice: bld.opt(bld.num('regularPrice')),
    actualPrice: bld.num('actualPrice'),
    promo: new PropDesc_1.PropDesc(new YesNoBooleanParser_1.YesNoBooleanParser('1', '0'), {
      nameKey: CompetitorPriceRawData.name + '_promo'
    }),
    sellout: bld.opt(new PropDesc_1.PropDesc(new YesNoBooleanParser_1.YesNoBooleanParser('1', '0'), {
      nameKey: CompetitorPriceRawData.name + '_sellout'
    })),
    category: bld.opt(bld.str('category')),
    ean: bld.opt(new PropDesc_1.PropDesc(new EANParser_1.EANParser(), {
      nameKey: CompetitorPriceRawData.name + '_ean'
    }, immutable_1.List.of(new EANValidator_1.EANValidator()))),
    eanDescription: bld.opt(bld.str('eanDescription')),
    date: bld.date('date', 'YYYY W E'),
    researchType: bld.opt(bld.senum('researchType', ResearchTypeEnum_1.ResearchTypeEnum, ResearchTypeEnum_1.RESEARCH_TYPE_LOOKUP)),
    available: bld.opt(new PropDesc_1.PropDesc(new YesNoBooleanParser_1.YesNoBooleanParser('1', '0'), {
      nameKey: CompetitorPriceRawData.name + '_available'
    })),
    productContent: bld.opt(bld.str('productContent')),
    productSpecification: bld.opt(bld.str('productSpecification')),
    supplier: bld.opt(bld.str('supplier')),
    comment: bld.opt(bld.str('comment')),
    isFromWebScraping: bld.bool('isFromWebScraping')
  };
}();

CompetitorPriceRawData.webScrapingSchema = function () {
  var bld = new StructPropBuilder_1.StructPropBuilder(CompetitorPriceRawData.name);
  return Object.assign(Object.assign({}, CompetitorPriceRawData.agencySchema), {
    externalProductId: bld.opt(bld.str('externalProductId', new RequireValidator_1.RequireValidator())),
    regularPrice: bld.opt(bld.num('regularPrice', new RequireValidator_1.RequireValidator())),
    category: bld.opt(bld.str('category', new RequireValidator_1.RequireValidator()))
  });
}();